
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "cross.icon",
  "use": "cross.icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"cross.icon\"><path fill=\"currentColor\" d=\"M18.36 19.78L12 13.41l-6.36 6.37-1.42-1.42L10.59 12 4.22 5.64l1.42-1.42L12 10.59l6.36-6.36 1.41 1.41L13.41 12l6.36 6.36z\" /></symbol>"
});
    sprite.add(symbol);
    export default class CrossIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="cross.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/cross.icon.svg